import { render, staticRenderFns } from "./TreeReportsTable.vue?vue&type=template&id=a38b1b76&"
import script from "./TreeReportsTable.vue?vue&type=script&lang=js&"
export * from "./TreeReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports